import { render, staticRenderFns } from "./PartnerRegister.vue?vue&type=template&id=518508e4&scoped=true"
import script from "./PartnerRegister.vue?vue&type=script&lang=js"
export * from "./PartnerRegister.vue?vue&type=script&lang=js"
import style0 from "./PartnerRegister.vue?vue&type=style&index=0&id=518508e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518508e4",
  null
  
)

export default component.exports